import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from './index';

export default class HelpTooltip extends React.PureComponent {
  state = {
    showTooltip: false,
  };

  constructor(props) {
    super(props);
  }

  onClose = () => {
    this.setState({ showTooltip: false });
  };

  onShow = () => {
    this.setState({ showTooltip: true });
  };

  render() {
    return (
      <div>
        <Tooltip
          content={this.props.content}
          title={null}
          show={this.state.showTooltip}
          onClose={this.onClose}
          onShow={this.onShow}
          {...this.props}
        />
      </div>
    );
  }
}

HelpTooltip.propTypes = {
  title: PropTypes.any,
  content: PropTypes.any.isRequired,
};
